import { GenIcon } from 'react-icons';
export const MdCurrencyFlagChf = GenIcon({
    tag: 'svg',
    attr: {
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    child: [
        {
            tag: 'g',
            attr: { clipPath: 'url(#clip0_21686_31090)' },
            child: [
                {
                    tag: 'rect',
                    attr: {
                        width: '24',
                        height: '24.0005',
                        fill: '#FFFFFF',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M23.0965 7.4371H13V9.27418H23.6866C23.5395 8.6446 23.3408 8.03083 23.0965 7.4371ZM20.7241 3.76174H13V5.60064H22.1479C21.7347 4.94493 21.2576 4.32873 20.7241 3.76174ZM3.3352 20.299H20.667C21.2036 19.74 21.6885 19.1256 22.1121 18.462H1.89255C2.31186 19.1177 2.79497 19.7333 3.3352 20.299ZM14.8824 0.35377C14.5221 0.264438 13.3597 0.0553006 13 0V1.92467H18.5194C17.4317 1.22096 16.2108 0.682535 14.8824 0.35377ZM23.9673 11.1112H13.0006V12.9501H23.9606C24.0105 12.3315 24.0117 11.7171 23.9673 11.1112ZM0.92998 16.6255H23.0716C23.3037 16.0682 23.4964 15.4861 23.6459 14.882C23.6538 14.8504 23.6604 14.8188 23.6683 14.7866H0.328979C0.480293 15.4168 0.681437 16.0324 0.92998 16.6255ZM9.11793 23.645C9.8277 23.8207 10.5387 23.9288 11.2436 23.9744H12.7707C14.801 23.8444 16.7401 23.1984 18.4179 22.1361H5.57695C6.6404 22.8094 7.82842 23.3266 9.11793 23.645Z',
                        fill: '#DB1300',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M12 24.0005C5.38316 24.0005 0 18.6146 0 12.0003C0 5.38592 5.38581 0 12 0C18.6142 0 24 5.38327 24 12.0003C24 18.6173 18.6169 24.0005 12 24.0005Z',
                        fill: '#DB1300',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M19.6675 14.2961V9.69548H14.3002V4.32812H9.69975V9.69548H4.33252V14.2961H9.69975V19.6634H14.3002V14.2961H19.6675Z',
                        fill: '#FFFFFF',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M12 0.5C18.3512 0.5 23.4999 5.64869 23.5 12C23.5 18.3514 18.3513 23.501 12 23.501C5.64874 23.501 0.5 18.3514 0.5 12C0.500145 5.64869 5.64883 0.5 12 0.5Z',
                        stroke: 'white',
                    },
                    child: [],
                },
            ],
        },
        {
            tag: 'defs',
            attr: {},
            child: [
                {
                    tag: 'clipPath',
                    attr: { id: 'clip0_21686_31090' },
                    child: [
                        {
                            tag: 'rect',
                            attr: {
                                width: '24',
                                height: '24',
                                rx: '12',
                                fill: 'white',
                            },
                            child: [],
                        },
                    ],
                },
            ],
        },
    ],
});
